import { createContext } from 'react';

export const SignalRContext = createContext({
  connection: undefined,
  methods: [],
  setMethods: methodName => {},
});

export default {};
